import Readme from 'gatsby-theme-mono/README.md';
import * as React from 'react';
export default {
  Readme,
  React
};